import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { PartnerPage } from "./partner";
import { catalogSize } from "../lib/api/lidoo.functions";
import { DICTS, LOCALIZED_LANGS, type Lang } from "../lib/i18n";
import { hreflangLinks } from "../lib/seo";

export const Route = createFileRoute("/$locale/partner")({
  beforeLoad: ({ params }) => {
    if (params.locale === "en") throw redirect({ to: "/partner" });
    if (!LOCALIZED_LANGS.includes(params.locale as Lang)) throw notFound();
  },
  loader: async () => await catalogSize(),
  head: (ctx) => {
    const lang = ctx.params.locale as Lang;
    const d = DICTS[lang];
    return {
      meta: [
        { title: `${d.b2b_title} | sunbedly` },
        { name: "description", content: d.b2b_sub },
      ],
      links: hreflangLinks("/partner", ctx.params.locale),
    };
  },
  component: () => <PartnerPage stats={Route.useLoaderData()} />,
});
